import { SelectOption } from 'common/types/select-option';
import _ from 'lodash';

const emptyOption = { id: '', label: '' };
const starAnyOption = { id: '*', label: 'Any' };

export enum SelectBuildOption {
  none,
  includeEmpty = 1 << 1,
  includeStarAny = 1 << 2,
  includeUnknown = 1 << 4,
  hideOther = 1 << 8,
}

const build = (e: any, values: any, option?: SelectBuildOption) => {
  let options: SelectOption[] = [
    ...(option && (option & SelectBuildOption.includeStarAny) === SelectBuildOption.includeStarAny
      ? [starAnyOption]
      : []),
    ...(option && (option & SelectBuildOption.includeEmpty) === SelectBuildOption.includeEmpty ? [emptyOption] : []),
    ...Object.keys(e).map(x => ({
      id: x,
      label: values[x],
    })),
  ];
  if (!(option && (option & SelectBuildOption.includeUnknown) === SelectBuildOption.includeUnknown))
    options = options.filter(x => x.id !== 'unknown');
  if (option && (option & SelectBuildOption.hideOther) === SelectBuildOption.hideOther)
    options = options.filter(x => x.id !== 'other');

  return options;
};

function fromStrings(values: string[], sort?: boolean, initOption?: SelectOption) {
  let options: SelectOption[] = values.map(x => ({
    id: x,
    label: x,
  }));
  if (sort) options = _.orderBy(options, ['label']);
  return [...(initOption ? [initOption] : []), ...options];
}

function fromObjects(values: any[], idKey: string, labelKey: string, sort?: boolean, initOption?: SelectOption) {
  let options: SelectOption[] = values.map(x => ({
    id: x[idKey],
    label: x[labelKey],
  }));
  if (sort) options = _.orderBy(options, ['label']);
  return [...(initOption ? [initOption] : []), ...options];
}

export const selectOptionTools = {
  build,
  fromStrings,
  fromObjects,
};
